import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';
import { ROW_COLUMNS } from './components/styles';

const { fontSizes, fontWeights } = THEME.typography;

export const styleSheet = StyleSheet.create({
	body: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
	},
	columns: {
		color: THEME.colors.text.light,
		columnGap: `${SPACE[16]}px`,
		display: 'grid',
		fontSize: fontSizes.xs,
		fontWeight: fontWeights.semibold,
		gridTemplateColumns: ROW_COLUMNS,
		padding: `0 ${SPACE[16]}px`,
		[THEME.queries.lg]: {
			display: 'none',
		},
	},
	list: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
	},
	cardGrid: {
		display: 'grid',
		gap: SPACE[16],
		gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
		[THEME.queries.md]: {
			gridTemplateColumns: 'minmax(0, 1fr)',
		},
	},
	message: {
		alignItems: 'center',
		color: THEME.colors.text.light,
		display: 'flex',
		flexDirection: 'column',
		fontSize: fontSizes.sm,
		gap: SPACE[12],
		padding: `${SPACE[48]}px ${SPACE[16]}px`,
		textAlign: 'center',
	},
	loadMoreError: {
		alignItems: 'center',
		color: THEME.colors.text.light,
		display: 'flex',
		fontSize: fontSizes.sm,
		gap: SPACE[12],
		justifyContent: 'center',
		padding: SPACE[16],
	},
	skeletonRow: {
		borderRadius: THEME.common.borderRadius,
		height: 64,
	},
});
